import { createFileRoute } from "@tanstack/react-router";
import { queryClient } from "@/ajax/queryClient";
import { useProviderUser } from "@/hooks/useProviderUser";
import { CredentialsPage } from "@/features/credentials/components/credentials-page";
import { trpc } from "@/trpc";

export const Route = createFileRoute("/_provider/provider/credentials/")({
  // Keep the provider route's pending screen mounted through profile loading.
  wrapInSuspense: false,
  loader: async ({ parentMatchPromise }) => {
    // Wait for authentication, MFA and onboarding before loading this record.
    const parentMatch = await parentMatchPromise;
    if (parentMatch.status !== "success" || !parentMatch.loaderData) {
      throw parentMatch.error ?? new Error("Unable to load your profile.");
    }
    const { providerUser } = parentMatch.loaderData;
    const credentials = queryClient.ensureQueryData(
      trpc.credentials.getMyCredentials.queryOptions({
        switchUserId: providerUser.id,
      }),
    );
    const requests: Promise<unknown>[] = [credentials];
    if (providerUser.jobPostsEnabled) {
      requests.push(
        queryClient.ensureQueryData(
          trpc.profile.getJobPreferences.queryOptions({
            userId: providerUser.id,
          }),
        ),
      );
    }
    await Promise.all(requests);
  },
  component: ProviderCredentialsPage,
});

function ProviderCredentialsPage() {
  const providerUser = useProviderUser();
  return <CredentialsPage user={providerUser} />;
}
